<footer class="footer layout horizontal center middle" [ngStyle]="{'background-color': appearance.cookiePolicyFooter.bgColor}">
    <div [innerHtml]="'COOKIE_POLICY_FOOTER.MESSAGE'|translate"></div>
    <app-button [label]="'COOKIE_POLICY_FOOTER.ACCEPT'|translate" primary="true" (click)="acceptCookiePolicy()" style="margin-inline-start: 10px"></app-button>
</footer>